import { CodeBitsSearchFilter } from '../../api/public/code-api';

export const SlCodeBitsContext = 'mf_slCodeBits_context';

export const orderFilerType = {
	[CodeBitsSearchFilter[5]]: 'web-code.order-trending',
	[CodeBitsSearchFilter[1]]: 'web-code.order-most-recent',
	[CodeBitsSearchFilter[6]]: 'web-code.order-my-code-bits',
	[CodeBitsSearchFilter[2]]: 'web-code.order-most-popular',
};

export const orderFilerTypeAlias = {
	[CodeBitsSearchFilter[5]]: 'Trending',
	[CodeBitsSearchFilter[1]]: 'MostRecent',
	[CodeBitsSearchFilter[6]]: 'MyCodeBits',
	[CodeBitsSearchFilter[2]]: 'MostPopular',
};

export const codeBitsFilerTrackingType = {
	[CodeBitsSearchFilter[5]]: 'TRENDING',
	[CodeBitsSearchFilter[1]]: 'MOST RECENT',
	[CodeBitsSearchFilter[6]]: 'MY CODE BITS',
	[CodeBitsSearchFilter[2]]: 'MOST POPULAR',
};

export const HOT_TODAY_PROJECTS_COUNT = 10;

export const CODE_BITS_LIST_COUNT = 20;
